export default Object.freeze({
  KEINE: 'KEINE',
  BESICHTIGUNG: 'BESICHTIGUNG',
  values: function () {
    return [this.KEINE, this.BESICHTIGUNG];
  }
});
